module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repost-payment-modal"
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), (!_vm.show_error_dialog) ? _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "modal__header",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("\n        You are requesting a repost from\n        "), _c('span', [_vm._v(_vm._s(_vm.receiver.username))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "modal__content",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "repost-item"
  }, [_c('div', {
    staticClass: "repost-item-image",
    style: ({
      'background-image': 'url(' + _vm.itemCover + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "repost-item-title"
  }, [_vm._v(_vm._s(_vm.itemTitle))]), _vm._v(" "), _c('div', {
    staticClass: "repost-item-owner"
  }, [_vm._v(_vm._s(_vm.itemOwner))])]), _vm._v(" "), _c('div', {
    staticClass: "payment"
  }, [_c('p', [_vm._v("\n          This user charge\n          "), _c('strong', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.receiver.repost_price)))]), _vm._v(" for\n          repost requests.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          You card isn't charged unless this user choose to repost your\n          content. Users can accept, deny, or repost for free. If the user\n          doesn't respond in 1 day, the request is automatically denied\n        ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "payment-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('card', {
    staticClass: "stripe-card pa-2",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.complete = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fee-section pl-2 pr-2"
  }, [_c('label', {
    staticClass: "fee-amount"
  }, [_vm._v("fee: $" + _vm._s(_vm._f("formatNumber")(_vm.fee)))])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "action-section",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "pay-btn",
    attrs: {
      "disabled": _vm.sent_payment || !_vm.complete
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendPayment()
      }
    }
  }, [_vm._v("Pay: $" + _vm._s(_vm._f("formatNumber")((_vm.amount + _vm.fee))))])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "modal__footer",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("All transaction powered by "), _c('span', [_vm._v("Stripe.com")])])])], 1) : _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1",
      "persistent": ""
    },
    model: {
      value: (_vm.show_error_dialog),
      callback: function($$v) {
        _vm.show_error_dialog = $$v
      },
      expression: "show_error_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm._.get(_vm.receiver, 'avatar.thumb.url'),
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("You cannot send the payment")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm._.get(_vm.receiver, "display_name", "Receiver")) + " did not connect to\n          stripe yet.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_error_dialog = false;
        _vm.dismiss();
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5610e367","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/repost_payment_modal.vue
// module id = 1728
// module chunks = 180